import { render, staticRenderFns } from "./FriendshipGroups.vue?vue&type=template&id=13da1333"
import script from "./FriendshipGroups.vue?vue&type=script&lang=js"
export * from "./FriendshipGroups.vue?vue&type=script&lang=js"
import style0 from "./FriendshipGroups.vue?vue&type=style&index=0&id=13da1333&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports